export const contentWidth =
  window.location.href.indexOf("/editor/") > 0
    ? "content col-xs-12"
    : "content col-xs-12 col-sm-8 col-sm-offset-2 col-lg-6 col-lg-offset-3"

export const SITE_URL = window.location.href
  .split("/")
  .slice(0, 3)
  .join("/")

export const TERMS_URL = `${SITE_URL}/terms/`
export const PRIVACY_URL = `${SITE_URL}/privacy/`
export const SYMPTOMS_URL = `${SITE_URL}/symptoms-a-z/`

const base_tag = document.getElementById("api_base")
export const BASE = base_tag ? base_tag.value : ""

const image_url_tag = document.getElementById("image_url")
export const IMAGE_URL = image_url_tag ? image_url_tag.value : "/static/images/"

const static_url_tag = document.getElementById("static_url")
export const STATIC_URL = static_url_tag ? static_url_tag.value : "/static/"

const svg_url_tag = document.getElementById("svg_url")
export const SVG_URL = svg_url_tag ? svg_url_tag.value : "/static/images/"

const environment_tag = document.getElementById("environment")
export const ENVIRONMENT = environment_tag ? environment_tag.value : "local"

const is_production_tag = document.getElementById("is_production")
export const IS_PRODUCTION = is_production_tag
  ? is_production_tag.value === "True"
  : false

export const PRE_IDENTIFIERS = "pre identifiers"

const stripe_api_tag = document.getElementById("stripe_api_key")
export const STRIPE_API_KEY = stripe_api_tag ? stripe_api_tag.value : ""

const sentry_release_tag = document.getElementById("sentry_release")
export const SENTRY_RELEASE = sentry_release_tag ? sentry_release_tag.value : ""

const amplitude_tag = document.getElementById("amplitude_token")
export const AMPLITUDE_TOKEN = amplitude_tag ? amplitude_tag.value : ""

export const insuranceTooltip =
  "Before seeking care, confirm that the provider and location are participating in your health insurance plan. If you are insured by any other plan than the one listed here, please check with your health insurance plan to identify a participating provider."



// WEBPACK FOOTER //
// ./assets/common/constants.js